import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { withTranslation } from '../../../ChildrenContext.js';
import PropTypes from 'prop-types';
import DataComponent from '../../../DataComponent/DataComponent';

const FinanceReportList = ({ 
    list, 
    total, 
    page, 
    loading, 
    headerNames, 
    getFinanceOperations, 
    t 
}) => {
    const [state, setState] = useState({
        list: [],
        totalPages: total,
        page: page,
        loading: loading,
        isTableLast: true
    });

    const staticNameTable = (t && t.dataTable) || {};
    const staticNameFinanceOperations = (t && t.financeReportPage && t.financeReportPage.financeItem) || '';

    const processList = useCallback((newList, newHeaderNames) => {
        const processedList = [];
        
        for (let financeOperations of newList) {
            let financeOperationsFiltered = {};
            let pushFinanceOperations = false;
            
            for (let dataField in financeOperations) {
                const header = newHeaderNames.find(header => header.keyTitle === dataField);
                if (header && header.visible) {
                    financeOperationsFiltered[dataField] = financeOperations[dataField];
                    if (!pushFinanceOperations) {
                        pushFinanceOperations = true;
                    }
                }
            }
            
            if (pushFinanceOperations) {
                processedList.push(financeOperationsFiltered);
            }
        }
        
        return processedList;
    }, []);

    useEffect(() => {
        const processedList = processList(list, headerNames);
        
        setState(prevState => ({
            ...prevState,
            list: processedList,
            totalPages: total,
            page: page,
            loading: loading
        }));
    }, [list, total, page, loading, headerNames, processList]);

    const onDataTableAction = useCallback((state) => {
        getFinanceOperations(state);
    }, [getFinanceOperations]);

    const fields = useMemo(() => [
        {
            name: 'dynamic',
            key: 'advertiser',
            segment: 'Advertiser',
            label: staticNameTable.headers?.advertiserTitle,
            dropdownLabel: staticNameTable.filter,
        },
        {
            name: 'dynamic',
            key: 'period',
            segment: 'Period',
            label: staticNameTable.headers?.periodTitle,
            dropdownLabel: staticNameTable.filter,
        }
    ], [staticNameTable]);

    return (
        <div className="history-postback__table">
            <DataComponent
                onAction={onDataTableAction}
                totalPages={state.totalPages}
                headerNames={headerNames}
                data={state.list}
                loading={state.loading}
                isQuery={true}
                settings={true}
                settingKey={'financeOperations'}
                tableBodyTitle={staticNameFinanceOperations}
                className="report-table simple-table green-hover report-table_last"
                gray={true}
                fields={fields}
            />
        </div>
    );
};

FinanceReportList.propTypes = {
    list: PropTypes.array,
    total: PropTypes.number,
    page: PropTypes.number,
    loading: PropTypes.bool,
    headerNames: PropTypes.array,
    getFinanceOperations: PropTypes.func,
    t: PropTypes.object
};

FinanceReportList.defaultProps = {
    list: [],
    total: 0,
    page: 1,
    loading: false,
    headerNames: [],
    getFinanceOperations: () => {}
};

export default withTranslation(FinanceReportList);
